import { Icon } from '@internal/kern-ux';

/** Icons that KERN only provides as CSS classes (not typed in the React kit). */
const cssIcon = (name: string) => (
  <span className={`kern-icon kern-icon--${name}`} aria-hidden="true" />
);

/**
 * KERN icons for the symbols Backstage uses everywhere.
 *
 * Only replaced where KERN has a fitting symbol — an invented icon would be worse than the
 * neutral default.
 *
 * Registered as elements, not components: the component form is deprecated in
 * Backstage 1.54.
 */
export const kernIcons = {
  search: <Icon name="search" />,
  email: <Icon name="mail" />,
  help: <Icon name="help" />,
  warning: <Icon name="warning" />,
  externalLink: <Icon name="open-in-new" />,
  user: cssIcon('account-circle'),
  group: cssIcon('account-circle'),
  docs: cssIcon('draft'),
  techdocs: cssIcon('draft'),
  'kind:user': cssIcon('account-circle'),
  'kind:group': cssIcon('account-circle'),
};
